"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_rx_1 = require("./util_rx");
const util_1 = require("./util");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const touch_dom_1 = require("./touch_dom");
class TTap {
    constructor(touch, // The first touch of the tap
    tStart = util_1.now(), // Time that the first tap happened
    tPress = 0, // How long the press was
    event = null) {
        this.touch = touch;
        this.tStart = tStart;
        this.tPress = tPress;
        this.event = event;
    }
}
exports.TTap = TTap;
class TPress {
    // eslint-disable-next-line no-useless-constructor
    constructor(touch, // The first touch of the tap
    tStart, // Time that the first tap happened
    tPress, // How long the press was
    event = null) {
        this.touch = touch;
        this.tStart = tStart;
        this.tPress = tPress;
        this.event = event;
    }
}
exports.TPress = TPress;
// Observable of true/false based on the first event of the source.
//
function detectFirst(f) {
    return (source) => source.pipe(operators_1.first(null, null), operators_1.map((t) => f(t)));
}
exports.detectFirst = detectFirst;
// Returns a `true` the first time the gesture is detected multi-finger pinch,
// or a `false` if gesture ends of after a timeout.
//
function isPinch$(timeout) {
    return (source) => source.pipe(operators_1.filter(e => e.touches.length >= 2), operators_1.map(_ => true), operators_1.takeUntil(rxjs_1.interval(timeout)), operators_1.first(_ => _, false));
}
exports.isPinch$ = isPinch$;
function hasButton$(button) {
    return source => source.pipe(operators_1.map(e => {
        const b = e.touches && e.touches[0] && e.touches[0].button;
        return b === button;
    }), operators_1.first(b => b, false));
}
exports.hasButton$ = hasButton$;
// Returns a `true` the first time the gesture is detected to be a drag/pinch,
// or a `false` at the end if not detected.
//
function detectDragOrPinch(maxDrag) {
    return (source) => source.pipe(isDragOrPinch(maxDrag), operators_1.first(_ => _, false));
}
exports.detectDragOrPinch = detectDragOrPinch;
// Returns a true or false for each event if the new event would be considered
// a drag/pinch.
//
function isDragOrPinch(maxDrag) {
    // Produces true for each event corresponds to a drag or pinch or not.
    const maxDrag2 = maxDrag * maxDrag;
    return (source) => source.pipe(util_rx_1.pairFirst(), operators_1.map(([eventFirst, event]) => {
        if (eventFirst.touches.length !== 1 || event.touches.length !== 1)
            return true;
        else {
            const t1 = eventFirst.touches[0];
            const t2 = event.touches[0];
            const v = t1.point.subtract(t2.point);
            const d = v.magnitude2();
            return (d > maxDrag2);
        }
    }));
}
exports.isDragOrPinch = isDragOrPinch;
function tapsFromGesture(gesture, maxDrag = 10.0) {
    // Only true at end of gesture if throughout if all no drag or pinch
    const valid = gesture.pipe(isDragOrPinch(maxDrag), operators_1.every(b => !b), operators_1.filter(b => b));
    // Zip this signal with the first and last events, and from them
    // produce the tap.
    return rxjs_1.zip(valid, gesture.pipe(operators_1.first())).pipe(operators_1.map(([valid, eFirst]) => new TTap(eFirst.touches[0], eFirst.t, util_1.now() - eFirst.t, eFirst)));
}
exports.tapsFromGesture = tapsFromGesture;
function isDoubleTap(duration, distance, tap0, tap1) {
    const t0 = tap0.tStart;
    const t1 = tap1.tStart;
    const p0 = tap0.touch.point;
    const p1 = tap1.touch.point;
    return (t1 - t0 <= duration &&
        p0.distanceWithin(p1, distance));
}
exports.isDoubleTap = isDoubleTap;
function doubleTaps(duration, distance) {
    return src$ => src$.pipe(operators_1.pairwise(), operators_1.filter(taps => isDoubleTap(duration, distance, ...taps)));
}
exports.doubleTaps = doubleTaps;
function pressesFromGesture(gesture, maxDuration, maxDrag = 10.0) {
    const g$ = gesture;
    const stop$ = g$.pipe(detectDragOrPinch(maxDrag));
    return g$.pipe(operators_1.take(1), operators_1.delay(maxDuration), operators_1.takeUntil(stop$), operators_1.map(eFirst => new TPress(eFirst.touches[0], eFirst.t, util_1.now() - eFirst.t, eFirst)), touch_dom_1.taplogT("++++ press"));
}
exports.pressesFromGesture = pressesFromGesture;
